import {
  FieldWrapper,
  InterpretationContainer,
  InterpretationText,
  SwapButton,
} from "styles/formStyleComponents";

const InterpretationFieldComponent = ({
  name,
  label,
  value,
  onChange,
  value0Label = "0",
  value1Label = "1",
  default0Value = "Normal",
  default1Value = "Failed",
}) => {
  const swapInterpretation = () => {
    const current = value || { "0": default0Value, "1": default1Value };
    const swappedValue = {
      "0": current["1"],
      "1": current["0"],
    };
    onChange(name, swappedValue);
  };

  const currentValue = value || { "0": default0Value, "1": default1Value };

  return (
    <FieldWrapper>
      <InterpretationContainer>
        <InterpretationText>
          {label || "Interpretation"}: {value0Label} = {currentValue["0"] || default0Value}, {value1Label} = {currentValue["1"] || default1Value}
        </InterpretationText>
        <SwapButton
          component="button"
          variant="body2"
          onClick={swapInterpretation}
        >
          SWAP
        </SwapButton>
      </InterpretationContainer>
    </FieldWrapper>
  );
};

export default InterpretationFieldComponent;

